<template>
	<el-dialog
		class="settings-password-dialog im-dialog-shell im-dialog-shell--sm im-dialog-shell--mobile-center"
		title="修改密码"
		:visible.sync="dialogVisible"
		:width="dialogWidth"
		:append-to-body="true"
		:close-on-click-modal="false"
		:close-on-press-escape="!submitting"
		:before-close="handleBeforeClose"
		@closed="resetForm"
	>
		<el-form
			ref="passwordForm"
			class="password-form"
			:model="formData"
			label-position="top"
			:rules="rules"
			size="small"
		>
			<el-form-item prop="oldPassword" label="原密码">
				<el-input
					v-model="formData.oldPassword"
					type="password"
					autocomplete="off"
					maxlength="20"
					:disabled="submitting"
					placeholder="请输入当前密码"
				></el-input>
			</el-form-item>
			<el-form-item prop="newPassword" label="新密码">
				<el-input
					v-model="formData.newPassword"
					type="password"
					autocomplete="off"
					maxlength="20"
					:disabled="submitting"
					placeholder="请输入新密码"
				></el-input>
			</el-form-item>
			<el-form-item prop="confirmPassword" label="确认密码">
				<el-input
					v-model="formData.confirmPassword"
					type="password"
					autocomplete="off"
					maxlength="20"
					:disabled="submitting"
					placeholder="请再次输入新密码"
				></el-input>
			</el-form-item>
		</el-form>

		<span slot="footer" class="dialog-footer">
			<el-button :disabled="submitting" @click="close">取消</el-button>
			<el-button type="primary" :loading="submitting" @click="onSubmit">确认修改</el-button>
		</span>
	</el-dialog>
</template>

<script>
import {
	createConfirmPasswordValidator,
	sanitizeAlphaNumeric,
	validateExistingPassword,
	validatePassword
} from '../../utils/authValidators';

export default {
	name: 'SettingsPasswordDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		isMobile: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			submitting: false,
			formData: {
				oldPassword: '',
				newPassword: '',
				confirmPassword: ''
			},
			rules: {
				newPassword: [{
					validator: validatePassword,
					trigger: 'blur'
				}],
				oldPassword: [{
					validator: validateExistingPassword,
					trigger: 'blur'
				}],
				confirmPassword: [{
					validator: createConfirmPasswordValidator(() => this.formData.newPassword),
					trigger: 'blur'
				}]
			}
		};
	},
	computed: {
		dialogVisible: {
			get() {
				return this.visible;
			},
			set(value) {
				this.$emit('update:visible', value);
			}
		},
		dialogWidth() {
			return this.isMobile ? '92%' : '420px';
		}
	},
	watch: {
		visible(nextVisible) {
			if (nextVisible) {
				this.$nextTick(() => {
					this.$refs.passwordForm && this.$refs.passwordForm.clearValidate();
				});
			}
		},
		'formData.newPassword'(value) {
			const sanitized = sanitizeAlphaNumeric(value);
			if (sanitized !== value) {
				this.formData.newPassword = sanitized;
			}
		},
		'formData.confirmPassword'(value) {
			const sanitized = sanitizeAlphaNumeric(value);
			if (sanitized !== value) {
				this.formData.confirmPassword = sanitized;
			}
		}
	},
	methods: {
		handleBeforeClose(done) {
			if (this.submitting) {
				return;
			}
			done();
		},
		close() {
			if (this.submitting) {
				return;
			}
			this.dialogVisible = false;
		},
		resetForm() {
			this.formData.oldPassword = '';
			this.formData.newPassword = '';
			this.formData.confirmPassword = '';
			this.submitting = false;
			this.$nextTick(() => {
				if (this.$refs.passwordForm) {
					this.$refs.passwordForm.resetFields();
				}
			});
		},
		onSubmit() {
			if (!this.$refs.passwordForm || this.submitting) {
				return;
			}
			this.$refs.passwordForm.validate((valid) => {
				if (!valid) {
					return false;
				}
				this.submitting = true;
				this.$http({
					url: '/modifyPwd',
					method: 'put',
					data: this.formData
				}).then(() => {
					this.$message.success('修改成功');
					this.dialogVisible = false;
				}).catch((error) => {
					this.$message.error(error && error.message ? error.message : '修改密码失败');
				}).finally(() => {
					this.submitting = false;
				});
			});
		}
	}
};
</script>

<style scoped lang="scss">
.settings-password-dialog {
	.password-form {
		:deep(.el-form-item__label) {
			float: none;
			display: block;
			width: auto !important;
			padding-bottom: 6px;
			line-height: 1.2;
			font-size: 12px;
			color: var(--im-text-color-light);
			text-align: left;
		}

		:deep(.el-form-item__content) {
			margin-left: 0 !important;
			line-height: 1.4;
		}

		:deep(.el-form-item:last-child) {
			margin-bottom: 0;
		}
	}
}
</style>
